// @flow
/*global gproxy*/

class HelpStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  async createTicket(ticket) {
    return gproxy.customer.ticket.create(ticket);
  }

  async createOpenTicket(ticket) {
    return gproxy.contact.create(ticket);
  }

  async createWithdrawTicket(ticket, token) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ZENDESK_API_TICKET_URL}/withdraw-ticket`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...ticket, token }),
        },
      );

      if (!response.ok) {
        let errorMessage = 'Unknown error';

        try {
          const errorData = await response.json();
          errorMessage = errorData?.message || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }

        const error = new Error(errorMessage);
        error.status = response.status;
        throw error;
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}

export default HelpStore;
